// document.title = "人脸采集建模";
import { ref, defineComponent, onBeforeUnmount, reactive } from "vue";
import { showNotify } from "vant";
import Compressor from "compressorjs";
import { sendCode, savePerson } from "@/api/login";
import { upload } from "@/api/upload";
export default defineComponent({
  name: "AddPersonStudent",
  setup() {
    let modelForm = reactive({
      jobNum: "",
      name: "",
      phone: "",
      code: "",
      photoPath: "",
      cid: 100,
      personType: "student"
    });
    // 校验函数返回 true 表示校验通过，false 表示不通过
    const validPhone = val => /^(?:(?:\+|00)86)?1\d{10}$/.test(val);
    const formRef = ref();
    // 倒计时定时器
    let timer = 0;
    // 验证码显示文本
    const codeText = ref("获取验证码");
    // 是否禁用验证码按钮
    const codeDisabled = ref(false);
    const getCode = async () => {
      var _formRef$value;
      await ((_formRef$value = formRef.value) === null || _formRef$value === void 0 ? void 0 : _formRef$value.validate(["name", "jobNum", "phone"]));
      sendCode(modelForm).then(res => {
        console.log(res);
        showNotify({
          type: "success",
          message: "发送成功,请注意查收短信"
        });
        let time = 60;
        timer = setInterval(() => {
          if (time == 0) {
            clearInterval(timer);
            codeText.value = "获取验证码";
            codeDisabled.value = false;
          } else {
            codeDisabled.value = true;
            codeText.value = time + "秒后重试";
            time--;
          }
        }, 1000);
      });
    };
    onBeforeUnmount(() => {
      // 卸载定时器
      if (timer) {
        clearInterval(timer);
      }
    });
    const fileList = ref([]);
    const beforeRead = async file => {
      await new Promise(resolve => {
        // compressorjs 默认开启 checkOrientation 选项
        // 会将图片修正为正确方向
        new Compressor(file, {
          success: resolve,
          error(err) {
            console.log(err.message);
          }
        });
      });
    };
    const onOversize = file => {
      showNotify({
        type: "warning",
        message: "上传图片大小不能超过10M"
      });
    };
    const afterRead = file => {
      // 此时可以自行将文件上传至服务器
      console.log(file, file.status, file.file);
      file.status = "uploading";
      file.message = "上传中...";
      // const formData = new FormData();
      // formData.append("file", file.file);
      upload({
        file: file.file
      }).then(({
        data: {
          code,
          msg,
          data
        }
      }) => {
        console.log("then", code, msg);
        if (code !== 200) {
          file.status = "failed";
          file.message = "上传失败";
          fileList.value = [];
          return showNotify({
            type: "warning",
            message: msg
          });
        }
        file.status = "done";
        modelForm.photoPath = data.fileName;
      }).catch(err => {
        file.status = "failed";
        file.message = "上传失败";
        showNotify({
          type: "warning",
          message: err.msg
        });
      });
    };
    const loading = ref(false);
    const onSubmit = values => {
      console.log("submit", values, modelForm);
      loading.value = true;
      savePerson(modelForm).then(({
        code,
        msg
      }) => {
        if (code === 200) {
          showNotify({
            type: "success",
            message: msg
          });
          modelForm.jobNum = "";
          modelForm.name = "";
          modelForm.phone = "";
          modelForm.code = "";
          modelForm.photoPath = "";
          fileList.value = [];
          console.log(fileList.value, modelForm);
        }
      }).finally(() => {
        loading.value = false;
      });
    };
    return {
      modelForm,
      formRef,
      validPhone,
      codeText,
      codeDisabled,
      getCode,
      fileList,
      beforeRead,
      afterRead,
      onOversize,
      loading,
      onSubmit
    };
  }
});